import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/numberOfActiveMembersBySagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const CustomDateRanges = () => {
  const dispatch = useDispatch();

  const { rangeOptions, selectedRangeOption } = useSelector((state) => {
    const { rangeOptions, selectedRangeOption } = state.numberOfActiveMembersBy;
    return { rangeOptions, selectedRangeOption };
  }, shallowEqual);

  return (
    <MultiSelectDropdown
      options={rangeOptions}
      selectedFilters={selectedRangeOption}
      includeFilter={false}
      numberDisplayed={0}
      onSelectChange={(data) => dispatch(actionCreators.updateCustomRange(data))}
    />
  );
};
export default CustomDateRanges;
